export const speakWithUsText = {
  en: {
    title: "Speak with me",
    description:
      "Whether you're choosing your study pathway, preparing for university, or planning your next career step — I'm here to help you gain clarity and confidence.",

    form: {
      name: "Name",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      interest: "I'm Interested In",
      selectOption: "Select an option",
      option1: "Career Counselling (1:1)",
      option2: "Profile Building & University Mentorship",
      message: "Message",
      messagePlaceholder: "Write your message...",
      submit: "Submit",
    },

    toast: {
      sending: "Sending your message...",
      success:
        "Thank you for your enquiry. Our team will contact you as soon as possible.",
      error: "Something went wrong. Please try again ❌",
    },
  },

  vi: {
    title: "Trao Đổi Cùng Tôi",
    description:
      "Dù bạn đang chọn hướng học tập, chuẩn bị vào đại học hay lên kế hoạch cho bước ngoặt sự nghiệp tiếp theo — tôi luôn sẵn sàng đồng hành để giúp bạn rõ ràng và tự tin hơn.",

    form: {
      name: "Họ và Tên",
      firstName: "Tên",
      lastName: "Họ",
      email: "Email",
      interest: "Tôi Quan Tâm Đến",
      selectOption: "Vui lòng chọn",
      option1: "Tư Vấn Nghề Nghiệp (1:1)",
      option2: "Xây Dựng Hồ Sơ & Định Hướng Đại Học",
      message: "Lời Nhắn",
      messagePlaceholder: "Nhập nội dung bạn muốn chia sẻ...",
      submit: "Gửi",
    },

    toast: {
      sending: "Đang gửi tin nhắn...",
      success:
        "Cảm ơn bạn đã liên hệ. Chúng tôi sẽ phản hồi trong thời gian sớm nhất.",
      error: "Có lỗi xảy ra. Vui lòng thử lại ❌",
    },
  },
};
